import React from 'react';
import { Form, Input, Row, Col } from 'antd';
import styles from '../../pages/UpdatePersonalProfilePage.module.css';

export const UpdateContactInfoSection: React.FC = () => {
  return (
    <div className={styles.section}>
      <Row gutter={24} className={styles.formRow}>
        <Col span={12}>
          <Form.Item
            name="phone"
            label="Điện thoại"
            rules={[
              { required: true, message: 'Vui lòng nhập số điện thoại' },
              {
                pattern: /^\d{8,15}$/,
                message: 'Số điện thoại không hợp lệ',
              },
            ]}
          >
            <Input
              placeholder="Số điện thoại cá nhân"
              size="large"
              className={styles.input}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="personalEmail"
            label="Email cá nhân"
            rules={[
              { type: 'email', message: 'Email không hợp lệ' },
            ]}
          >
            <Input
              placeholder="Email cá nhân"
              size="large"
              className={styles.input}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24} className={styles.formRow}>
        <Col span={12}>
          <Form.Item name="permanentAddress" label="Thường trú">
            <Input
              placeholder="Địa chỉ thường trú"
              size="large"
              className={styles.input}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="permanentWard" label="Phường/Xã, Tỉnh/Thành">
            <Input
              placeholder="Phường/Xã, Tỉnh/Thành"
              size="large"
              className={styles.input}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24} className={styles.formRow}>
        <Col span={12}>
          <Form.Item name="currentAddress" label="Chỗ ở hiện nay">
            <Input
              placeholder="Địa chỉ hiện tại"
              size="large"
              className={styles.input}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="currentWard"
            label="Phường/Xã, Tỉnh/Thành hiện nay"
          >
            <Input
              placeholder="Phường/Xã, Tỉnh/Thành hiện nay"
              size="large"
              className={styles.input}
            />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

